import React from 'react';
import logoSMV from './logo_smv_autorizado.svg';
function LogoNegativoSMV() {
  return <img src={logoSMV} width="180" height="75" />;
}

export default LogoNegativoSMV;
